import { setAuth, setProfile } from "../reducers/authReducer";
import { setConfig } from "../reducers/configReducer";
import axios from "axios";
import getError from "../utils/getError";
import setAuthToken from "../utils/setAuthToken";
import url from "../utils/url";
import { isPermitted } from "../utils/PermissionManager";
import { masterFunction } from "../api/api";

export const loginAdmin = (data, loginAfterFunction) => (dispatch) => {
  axios
    .post(url + "/auth", data)
    .then((res) => {
      let resData = masterFunction(res, ".data");
      if (resData && resData.success) {
        const access_token =
          resData.access_token || resData.result?.access_token;
        let deviceInfo = null;
        if (window.deviceInfo) {
          deviceInfo = { ...window.deviceInfo };
        }
        setAuthToken(access_token, deviceInfo);
        dispatch(
          saveConfig((res) => {
            if (res) {
              localStorage.setItem("skyadmin", access_token);
              dispatch(setAuth(true));
            }
            loginAfterFunction(res);
          }),
        );
      } else {
        loginAfterFunction(false, "Result not successful no res.data.success");
      }
    })
    .catch((err) => {
      let error = getError(err);
      if (typeof error !== "string") {
        error = JSON.stringify(err);
      }
      loginAfterFunction(false, error);
    });
};

export const saveConfig = (afterAsync) => (dispatch) => {
  axios
    .get(url + "/config")
    .then((res) => {
      let configResult = masterFunction(res, ".result");
      if (configResult) {
        localStorage.setItem("config", JSON.stringify(configResult));
        let roles = configResult?.profile?.roles;
        let notCrmDelivery = isPermitted(roles, [
          "admin",
          "accountant",
          "bd_purchase",
          "cn_purchase",
          "support",
          "marketing",
          "china_basic",
          "china_crm",
          "china_purchase",
          "china_admin",
          "customer_care",
          "marketplace",
          "tax_vat",
          "cnf",
        ]);
        if (notCrmDelivery) {
          afterAsync(true);
          dispatch(setConfig(configResult));
          dispatch(setProfile(configResult?.profile));
        } else {
          localStorage.removeItem("skyadmin");
          localStorage.removeItem("config");
          setAuthToken(null);
          dispatch(setAuth(false));
          dispatch(setProfile(null));
          dispatch(setConfig(null));
          afterAsync(false);
          window.location.href = "/unauthorized";
        }
      }
    })
    .catch((err) => {});
};
export const saveProfile = () => (dispatch) => {
  axios
    .get(url + "/profile")
    .then((res) => {
      let profileResult = masterFunction(res, ".result");
      if (profileResult) {
        let role = profileResult?.role ? profileResult?.role : "";
        dispatch(setProfile(profileResult));
      }
    })
    .catch((err) => {});
};

export const logoutAdmin = (afterFunction) => (dispatch) => {
  axios
    .delete(url + "/auth")
    .then((res) => {})
    .catch((err) => {});
  localStorage.removeItem("skyadmin");
  localStorage.removeItem("config");
  setAuthToken(null);
  dispatch(setAuth(false));
  dispatch(setProfile(null));
  dispatch(setConfig(null));
  afterFunction(true);
};

export const setAdmin = (isAuthenticated) => (dispatch) => {
  dispatch(setAuth(isAuthenticated));
};
export const setAdminProfile = (data) => {
  return {
    type: "SET_ADMIN_PROFILE",
    payload: data,
  };
};

export const setAdminRole = (data) => {
  return {
    type: "SET_ADMIN_ROLES",
    payload: data,
  };
};
